export  const STORAGE_KEY_PREFIX = 'ticketScanner';
export  const API_URL = 'https://www.burgimspreewald.de/rqst/';
export  const API_AUTH_USER = 'ticketScanner';
export  const API_AUTH_TOKEN = 'YhO9wLirhF5CuNss63xkR9UqOO5pbuKsjT1G5ZUZjc0VQ3FHugreZzkEafY0q4Vh';